import _ from 'lodash';
import timm from 'timm';

import { Types } from 'app/actions/page-vol-event';
import utils from 'app/reducers/utils';

const initialState = {
  loadPending: false,
  volEventId: null,
  socialListingIds: [],
  socialMoreCount: 0,
};

const reducer = utils.createReducer(initialState, {

  [`${Types.LOAD}_PENDING`]: (state, {volEventId}) => {
    return {...state,
      loadPending: true,
      volEventId,
      socialListingIds: [],
      socialMoreCount: 0,
    };
  },
  [`${Types.LOAD}_RESOLVED`]: (state, {volEventId, result}) => {
    if (volEventId !== state.volEventId) return state;
    return {...state,
      loadPending: false,
      socialListingIds: result[1].socialPostListings.map(spl => spl.id),
      socialMoreCount: result[1].moreCount,
    };
  },
  [`${Types.LOAD}_REJECTED`]: (state, {volEventId}) => {
    if (volEventId !== state.volEventId) return state;
    return {...state,
      loadPending: false,
    };
  },


});

export default reducer;
